// extracted by mini-css-extract-plugin
module.exports = {"calendar":"ANIM4ARHYRjm0uCOuu5Gb"};